import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/pro-solid-svg-icons';

interface UnsupportedFilePreviewProps {
    fileType: string;
}

const UnsupportedFilePreview: React.FC<UnsupportedFilePreviewProps> = ({ fileType }) => (
    <div
        className="d-flex flex-column align-items-center justify-content-center w-100 h-100 text-dark"
        data-testid="unsupported-file-preview"
    >
        <FontAwesomeIcon icon={faFile} size="3x" className="mb-3" />
        <p className="mb-0 text-center">
            Document preview is not available at the moment
            <br />
            <span className="text-muted">for {fileType.toLowerCase()} files</span>
        </p>
    </div>
);

export default UnsupportedFilePreview;
